import React from 'react'

import { Divider } from '@factorialco/deprecated-design-system'

import { formatBackendDateToMonthDayLong } from 'modules/core/lib/dates'

import { BankOfHoursMovement } from 'modules/attendance/lib/utils/BankOfHoursUtils'

import Content from './Content'
import Header from './Header'

type Props = {
  movement: BankOfHoursMovement
}

const Item = ({ movement }: Props) => {
  const day = formatBackendDateToMonthDayLong(movement.date)
  const minutes = movement.minutes
  const accumulatedMinutes = movement.accumulatedMinutes
  const contributions = movement.contributions

  const [open, setOpen] = React.useState(false)

  return (
    <>
      <Header
        day={day}
        minutes={minutes}
        accumulatedMinutes={accumulatedMinutes}
        onClick={() => setOpen(!open)}
        open={open}
      />
      <Divider />

      {open && <Content contributions={contributions} />}
    </>
  )
}

export default Item
